import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "variant", "upgradeSource"],
  _excluded2 = ["children", "upgradeSource"],
  _excluded3 = ["children"];
import { Button, Link } from 'breeze-intelligence-kit';
import { useUpgradePoint } from 'ui-addon-upgrades/ums/useUpgradePoint';
import { UpgradeIcon } from 'foundations-assets/icons/components/UpgradeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useOnUpgrade = upgradeSource => {
  const {
    openUpgradePage: onUpgrade
  } = useUpgradePoint(upgradeSource);
  return {
    onUpgrade
  };
};
export const UpgradeLink = _ref => {
  let {
      children,
      variant,
      upgradeSource
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    onUpgrade
  } = useOnUpgrade(upgradeSource);
  return /*#__PURE__*/_jsx(Link, Object.assign({}, rest, {
    onClick: onUpgrade,
    use: variant,
    children: children
  }));
};
export const UpgradeButton = _ref2 => {
  let {
      children,
      upgradeSource
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    onUpgrade
  } = useOnUpgrade(upgradeSource);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    onClick: onUpgrade,
    children: children
  }));
};
export const UpgradeButtonIcon = _ref3 => {
  let {
      children
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(UpgradeButton, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(Button.Icon, {
      children: /*#__PURE__*/_jsx(UpgradeIcon, {})
    }), children]
  }));
};